import { createSlice } from "@reduxjs/toolkit";
import { userContestThunk,getAllContestThunk,getContestDetailThunk,
  createContestThunk,resetContestThunk,
  createParticipateContestThunk,
  saveContestResultThunk,
  getContestResultThunk,
  saveContestPublishStatusThunk,
  resultSendToClientThunk,
  handleStartDesignThunk,
  getAllStatusesThunk

 } from "./thunk";

export const initialState = {

  error: null,
  isLoading: false,
  isSuccess: false,
  contestList:[],
  contestResult:[],
  isCreateContest:false,
  isParticipate: false,
  isSaveResult:false,
  newContest:null,
  isContestPublish:false,
  isDesigningStart:false,
  requestDetail:[],
  statusesList:[]
};

const UserContestlice = createSlice({
  name: "contest",
  initialState,
  reducers: {
    resetFlags: (state) => {
      state.isLoading = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {

    // checkout User
    builder.addCase(userContestThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
      state.newContest=null;
    });
    builder.addCase(userContestThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.newContest=action.payload;
    });
    builder.addCase(userContestThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.newContest=null;
      state.error = action.payload || "Something went wrong";
    });



      // get all contest
    builder.addCase(getAllContestThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getAllContestThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.contestList=action.payload.data
    });
    builder.addCase(getAllContestThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.contestList=[];
      state.error = action.payload || "Something went wrong";
    });


    //contest Detail
        builder.addCase(getContestDetailThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.contestList=[];
    });
    builder.addCase(getContestDetailThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.contestList=action.payload.data
    });
    builder.addCase(getContestDetailThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.contestList=[];
      state.error = action.payload || "Something went wrong";
    });

//Create contest
       builder.addCase(createContestThunk.pending, (state) => {
        state.isLoading = true;
        state.isCreateContest=false
     
    });
    builder.addCase(createContestThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isCreateContest = true;

    });
    builder.addCase(createContestThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isCreateContest = false;
      state.error = action.payload || "Something went wrong";
    });


    //resetContestThunk
       builder.addCase(resetContestThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess=false;
      state.isCreateContest=false
      state.contestList=[];
      state.contestResult=[]
      
    });


    //Create Participate contest
       builder.addCase(createParticipateContestThunk.pending, (state) => {
        state.isLoading = true;
        state.isParticipate=false
     
    });
    builder.addCase(createParticipateContestThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isParticipate = true;

    });
    builder.addCase(createParticipateContestThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isParticipate = false;
      state.error = action.payload || "Something went wrong";
    });


    
    //Save contest result
       builder.addCase(saveContestResultThunk.pending, (state) => {
        state.isLoading = true;
        state.isSaveResult=false
     
    });
    builder.addCase(saveContestResultThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isSaveResult = true;

    });
    builder.addCase(saveContestResultThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isSaveResult = false;
      state.error = action.payload || "Something went wrong";
    });

       //Get contest result
        builder.addCase(getContestResultThunk.pending, (state) => {
        state.isLoading = true;
        state.contestResult=[]
    });

    builder.addCase(getContestResultThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.contestResult=action.payload.data

    });

    builder.addCase(getContestResultThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.contestResult = [];
      state.error = action.payload || "Something went wrong";
    });

      //Save Contest Publish Status
        builder.addCase(saveContestPublishStatusThunk.pending, (state) => {
        state.isLoading = true;
        state.isContestPublish=false;
    });

    builder.addCase(saveContestPublishStatusThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isContestPublish=true;

    });

    builder.addCase(saveContestPublishStatusThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isContestPublish=false;
      state.error = action.payload || "Something went wrong";
    });


        //Send Result to Client
        builder.addCase(resultSendToClientThunk.pending, (state) => {
        state.isLoading = true;
        state.isSuccess=false;
    });

    builder.addCase(resultSendToClientThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isSuccess=true;

    });

    builder.addCase(resultSendToClientThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess=false;
      state.error = action.payload || "Something went wrong";
    });

    
//isDesigningStart
        builder.addCase(handleStartDesignThunk.pending, (state) => {
        state.isLoading = true;
        state.isDesigningStart=false;
    });

    builder.addCase(handleStartDesignThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.isDesigningStart=true;

    });

    builder.addCase(handleStartDesignThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isDesigningStart=false;
      state.error = action.payload || "Something went wrong";
    });


//statuses list
        builder.addCase(getAllStatusesThunk.pending, (state) => {
        state.isLoading = true;
        state.statusesList=[];
    });

    builder.addCase(getAllStatusesThunk.fulfilled, (state,action) => {
      state.isLoading = false;
      state.statusesList=action.payload.data

    });

    builder.addCase(getAllStatusesThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.statusesList=[];
      state.error = action.payload || "Something went wrong";
    });


  },
});


export default UserContestlice.reducer;
